import "./AstmE2016Explained.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import AstmHero from "./sections/AstmHero";
import AstmDetails from "./sections/AstmDetails";
import TechnicalQuote from "./sections/TechnicalQuote";
import Footer from "@/reusable_sections/Footer";
export default function AstmE2016ExplainedPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="AstmE2016Explained" />
      <AstmHero />
      <AstmDetails />
      <TechnicalQuote />
      <Footer />
    </div>;
}